module.exports = __webpack_public_path__ + "static/level_none.2855b7f4.png";